<template>
  <SalesRegisterTableCard :is-empty="! tableItems.length" :is-loaded="isLoaded">
    <table class="table register-table">
      <thead>
      <tr>
        <th class="text-center">SL No.</th>
        <th>Customer Name</th>
        <th>Contact No</th>
        <th v-if="hasCustomerLocation">Customer Location</th>
        <th v-if="hasCustomerGender">Gender</th>
        <th v-if="hasHasCustomerAge">Age</th>
        <th class="num">Sales Qty</th>
        <th class="num">Bonus Qty</th>
        <th class="num">Total Qty</th>
        <th class="num">Invoice Amount</th>
        <th class="num">Vat Amount</th>
        <th class="num">Total Amount</th>
        <th class="num">Discount Amount</th>
        <th class="num">Redeem Point</th>
        <th class="num">Net Bill Amount</th>
        <th class="num">COGS</th>
        <th class="num">Gross Profit</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, i) in tableItems" :key="i">
        <td class="text-center">{{ (currentPage - 1) * perPage + (i + 1) }}</td>
        <td>{{ item.customer_name }}</td>
        <td class="text-nowrap">{{ item.phone }}  {{ item.mobile_no }}</td>
        <td v-if="hasCustomerLocation">{{ item.customer_location }}</td>
        <td v-if="hasCustomerGender">{{ item.customer_gender }}</td>
        <td v-if="hasHasCustomerAge">{{ item.customer_age }}</td>
        <td class="num">{{ item.net_quantity }}</td>
        <td class="num">{{ item.bonus_quantity }}</td>
        <td class="num">{{ item.total_bonus_quantity }}</td>
        <td class="num">{{ commaFormat(item.net_invoice_amount) }}</td>
        <td class="num">{{ item.total_vat_amount ? commaFormat(item.total_vat_amount) : '' }}</td>
        <td class="num">{{ commaFormat(item.gross_invoice_amount) }}</td>
        <td class="num">{{ item.total_discount ? commaFormat(item.total_discount) : '' }}</td>
        <td class="num">{{ item.points_redeemed ? commaFormat(item.points_redeemed) : '' }}</td>
        <td class="num">{{ commaFormat(item.net_bill_amount) }}</td>
        <td class="num">{{ item.stocks_sum_stock_value ? commaFormat(item.stocks_sum_stock_value) : '' }}</td>
        <td class="num">{{ item.stocks_sum_profit_value ? commaFormat(item.stocks_sum_profit_value) : '' }}</td>
      </tr>
      </tbody>
      <tfoot v-if="isLastPage">
      <tr>
        <td colspan="3" class="register-total-label">Total</td>
        <td v-if="hasCustomerLocation"></td>
        <td v-if="hasCustomerGender"></td>
        <td v-if="hasHasCustomerAge"></td>
        <td class="num">{{ totalValue && totalValue.total_net_quantity }}</td>
        <td class="num">{{ totalValue && totalValue.total_bonus_quantity }}</td>
        <td class="num">{{ totalValue && totalValue.total_total_bonus_quantity }}</td>
        <td class="num">{{ totalValue && totalValue.total_net_invoice_amount }}</td>
        <td class="num">{{ totalValue && totalValue.total_vat_amount }}</td>
        <td class="num">{{ totalValue && totalValue.total_gross_invoice_amount }}</td>
        <td class="num">{{ totalValue && totalValue.discount_amount }}</td>
        <td class="num">{{ totalValue && totalValue.total_points_redeemed }}</td>
        <td class="num">{{ totalValue && totalValue.total_net_bill_amount }}</td>
        <td class="num">{{ totalValue && totalValue.stocks_sum_stock_value }}</td>
        <td class="num">{{ totalValue && totalValue.stocks_sum_profit_value }}</td>
      </tr>
      </tfoot>
    </table>
  </SalesRegisterTableCard>
</template>

<script setup>
import { computed } from 'vue'
import figureFormatter from '@/services/utils/figureFormatter'
import SalesRegisterTableCard from '@/components/molecule/company/inventory/product-sales-register/SalesRegisterTableCard.vue'

const { commaFormat } = figureFormatter()

const props = defineProps({
  tableItems: {
    type: Array
  },
  currentPage: Number,
  lastPage: Number,
  perPage: Number,
  totalValue: Object,
  isLoaded: {
    type: Boolean,
    default: true
  }
})

const isLastPage = computed(() => {
  if (! props.tableItems.length) return false
  return props.currentPage === props.lastPage
})

const hasCustomerLocation = computed(() => {
  return props.tableItems.some(item => item.customer_location && item.customer_location.trim() !== '')
})

const hasCustomerGender = computed(() => {
  return props.tableItems.some(item => item.customer_gender && item.customer_gender.trim() !== '')
})

const hasHasCustomerAge = computed(() => {
  return props.tableItems.some(item => item.customer_age && item.customer_age.trim() !== '')
})
</script>
